import { useEffect, useState } from "react";

// Dona simple en SVG puro (stroke-dasharray por segmento) — sin
// dependencias nuevas. Apta para distribuciones chicas (Riesgo,
// Probabilidad): pocas categorías, se prioriza legibilidad sobre precisión
// decimal. Más grande + trazo más grueso + leyenda con más aire, y un
// fade-in sutil al montar.
const RADIO = 40;
const CIRCUNFERENCIA = 2 * Math.PI * RADIO;

export function GraficoDona({
  datos,
}: {
  datos: { etiqueta: string; valor: number; color: string }[];
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const total = datos.reduce((acc, d) => acc + d.valor, 0);
  if (total === 0) {
    return <p className="text-sm text-texto-secundario">Sin datos para mostrar.</p>;
  }

  let acumulado = 0;
  const segmentos = datos
    .filter((d) => d.valor > 0)
    .map((d) => {
      const largo = (d.valor / total) * CIRCUNFERENCIA;
      const offset = acumulado;
      acumulado += largo;
      return { ...d, largo, offset };
    });

  return (
    <div className={`flex items-center gap-6 transition-opacity duration-500 ${visible ? "opacity-100" : "opacity-0"}`}>
      <svg viewBox="0 0 100 100" className="h-36 w-36 shrink-0 -rotate-90">
        <circle cx="50" cy="50" r={RADIO} fill="none" stroke="#E5E7EB" strokeWidth="16" />
        {segmentos.map((s) => (
          <circle
            key={s.etiqueta}
            cx="50"
            cy="50"
            r={RADIO}
            fill="none"
            stroke={s.color}
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={`${s.largo} ${CIRCUNFERENCIA - s.largo}`}
            strokeDashoffset={-s.offset}
          />
        ))}
      </svg>
      <ul className="space-y-2.5 text-base">
        {datos.map((d) => (
          <li key={d.etiqueta} className="flex items-center gap-2.5">
            <span className="h-3 w-3 flex-shrink-0 rounded-full" style={{ backgroundColor: d.color }} />
            <span className="font-medium text-texto">{d.etiqueta}</span>
            <span className="text-texto-secundario">({d.valor})</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
